export enum MarketType {
  /** 自选 */
  Collect = 'collect',
  /** USDT */
  USDT = 10007,
  /** BTC */
  BTC = 10005,
  /** 现货 */
  Spot = 'spot',
  /** 合约 */
  Contract = 'contract',
}

type MarketTab = {
  label: string
  marketType: MarketType
}

export const marketTabs: MarketTab[] = [
  {
    label: 'USDT',
    marketType: MarketType.USDT,
  },
  {
    label: '自选',
    marketType: MarketType.Collect,
  },
]

export const collectTabs: MarketTab[] = [
  {
    label: '现货',
    marketType: MarketType.Spot,
  },
  // {
  //   label: '合约',
  //   marketType: MarketType.Contract,
  // },
]

export enum ContractType {
  /** 自选 */
  Collect = 'collect',
  /** U 本位 */
  USDT = 'usdt',
}

type ContractTab = {
  label: string
  contractType: ContractType
}

export const contractTabs: ContractTab[] = [
  {
    label: '自选',
    contractType: ContractType.Collect,
  },
  {
    label: 'U本位',
    contractType: ContractType.USDT,
  },
]
